module.exports = __webpack_public_path__ + "media/images/icons/search-94c3ef9e2aa9a5fb41d59368aa74de7f.svg";